import { SVGProps } from 'react';

export const ClosedGateIcon = (props: SVGProps<SVGSVGElement>) => {
	const color = props.color ?? '#BEBEBE';
	return (
		<svg width='22' height='16' viewBox='0 0 22 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M16 2C16 1.44772 16.4477 1 17 1H18C18.5523 1 19 1.44772 19 2V15H16V2Z'
				stroke={color}
				strokeWidth='1.38'
			/>
			<path d='M14 15H21' stroke={color} strokeWidth='1.38' strokeLinecap='round' />
			<path
				d='M1 3C1 2.44772 1.44772 2 2 2H16V6H2C1.44772 6 1 5.55228 1 5V3Z'
				stroke={color}
				strokeWidth='1.38'
			/>
			<path d='M3 6L7 2' stroke={color} strokeWidth='1.38' strokeLinecap='round' />
			<path d='M9 6L13 2' stroke={color} strokeWidth='1.38' strokeLinecap='round' />
		</svg>
	);
};
